import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { ClientDashboardService } from '../../service/client-dashboard.service';
import { ClientDashboardState } from '../../state/client-dashboard.state';

@Component({
  selector: 'app-property-listings',
  templateUrl: './property-listings.component.html',
  styleUrls: ['./property-listings.component.scss'],
})
export class PropertyListingsComponent implements OnInit {
  @ViewChild('emailContent') emailContent: ElementRef;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  onDestroyNotifier$ = new Subject();
  openPropertyListingValue = false;
  user: any;
  clientMarketingEmailDetails: any;
  clientDetails: any;
  sentMailData: any;
  fileList = [];
  hasAttachments: boolean = false;
  propertyRecommended = [];
  propertyRecommendedAllData = [];
  pageIndex: number;
  constructor(
    private clientDashboardService: ClientDashboardService,
    private clientDashboardState: ClientDashboardState
  ) {}

  ngOnInit(): void {
    this.clientDashboardState.openPropertyDetailsSheet$.pipe(takeUntil(this.onDestroyNotifier$)).subscribe((status) => {
      this.openPropertyListingValue = status;
    });
    this.clientDashboardState.activeClientEmailHistory$
      .pipe(takeUntil(this.onDestroyNotifier$))
      .subscribe((res: any) => {
        this.clientMarketingEmailDetails = res;
      });
    this.clientDashboardState.activeClientMarketingDetails$
      .pipe(takeUntil(this.onDestroyNotifier$))
      .subscribe((res: any) => {
        this.clientDetails = res;
      });
    this.getMarketingPropertyHistory();
  }

  closeSheet() {
    this.openPropertyListingValue = false;
    this.clientDashboardState.openPropertyDetailsSheetValue = false;
  }

  getMarketingPropertyHistory() {
    let params = {
      email: this.clientDetails.email,
      statisticsId: this.clientMarketingEmailDetails.statisticsId,
    };
    this.clientDashboardService.fetchClientMarketingProperty(params).subscribe((res: any) => {
      if (res && res.data) {
        this.propertyRecommendedAllData = res.data;
        this.paginator.length = res.totalCount;
        this.pageChange();
      }
    });
  }

  pageChange(event?) {
    const startIndex = this.paginator.pageIndex * this.paginator.pageSize;
    const endIndex = startIndex + this.paginator.pageSize;
    const currentPageData = this.propertyRecommendedAllData.slice(startIndex, endIndex);
    this.propertyRecommended = currentPageData;
  }

  ngOnDestroy() {
    this.onDestroyNotifier$.next();
    this.onDestroyNotifier$.complete();
  }
}
